export type NewsBlock =
  | { type: "paragraph"; text: string }
  | { type: "heading"; text: string }
  | { type: "image"; src: string; alt: string }
  | { type: "quote"; text: string };

export interface NewsArticle {
  id: string;
  title: string;
  category: string;
  date: string;
  author: string;
  cover: string;
  summary: string;
  content: NewsBlock[];
}

export const newsCategories = [
  { key: "all", label: "全部资讯" },
  { key: "品牌动态", label: "品牌动态" },
  { key: "产品发布", label: "产品发布" },
  { key: "品牌活动", label: "品牌活动" },
  { key: "行业观察", label: "行业观察" },
];

export const news: NewsArticle[] = [
  {
    id: "spring-launch-2026",
    title: "糖心VLGO 2026 春季新品发布会圆满举行",
    category: "品牌动态",
    date: "2026-03-18",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Warm%20coral%20toned%20brand%20product%20launch%20event%20stage%20with%20soft%20lighting%20and%20elegant%20decor%2C%20blurred%20audience%2C%20modern%20minimal%20conference%20atmosphere%2C%20premium%20brand%20photography&width=1200&height=750&seq=tx-news-spring&orientation=landscape",
    summary: "糖心VLGO 在本季发布了多款新品，围绕「真实果味」与「少糖配方」持续升级，现场邀请嘉宾共同见证品牌新一年的甜蜜计划。",
    content: [
      { type: "paragraph", text: "3 月 18 日，糖心VLGO 2026 春季新品发布会在城市艺术中心举行。来自各地的合作伙伴、媒体嘉宾与品牌挚友齐聚一堂，共同见证糖心VLGO 新一季的产品阵容与品牌主张。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Modern%20minimal%20product%20launch%20stage%20in%20warm%20coral%20tones%20with%20soft%20lighting%20and%20elegant%20decor%2C%20luxury%20brand%20event%20photography&width=1200&height=750&seq=tx-news-spring-in1&orientation=landscape", alt: "糖心VLGO 春季新品发布会现场" },
      { type: "heading", text: "围绕「真实果味」持续升级" },
      { type: "paragraph", text: "本次发布会以「真实一点，甜一点」为主题。品牌团队介绍了新一季在产品研发上的三条主线：真实果汁添加、减糖配方优化，以及更环保的包装材料。" },
      { type: "paragraph", text: "其中，升级后的莓莓夹心软糖采用更大比例的果酱夹心，酸甜比再次微调，口感更接近新鲜水果。" },
      { type: "quote", text: "我们希望每一口都能让人想起水果本来的味道，而不是糖的味道。" },
      { type: "heading", text: "新一年的甜蜜计划" },
      { type: "paragraph", text: "发布会上，品牌还预告了与插画师的联名企划、线下快闪体验店以及会员专属福利等内容，让品牌与用户之间有更多真实的连接。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Elegant%20coral%20brand%20event%20table%20with%20packaged%20candy%20gifts%20and%20flowers%2C%20soft%20warm%20lighting%2C%20clean%20minimal%20styling%2C%20premium%20photography&width=1200&height=750&seq=tx-news-spring-in2&orientation=landscape", alt: "发布会现场的产品陈列与花艺布置" },
    ],
  },
  {
    id: "berry-gummy-upgrade",
    title: "「莓莓夹心软糖」全新升级上市",
    category: "产品发布",
    date: "2026-02-26",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Premium%20strawberry%20filled%20gummy%20candies%20in%20an%20open%20warm%20coral%20gift%20box%20with%20fresh%20strawberries%2C%20clean%20soft%20cream%20background%2C%20soft%20studio%20light%2C%20appetizing%20food%20photography&width=1200&height=750&seq=tx-news-berry&orientation=landscape",
    summary: "莓莓夹心软糖迎来配方升级：果酱夹心比例提升，减糖约 30%，酸甜更清爽，口感更接近真实草莓。",
    content: [
      { type: "paragraph", text: "作为糖心VLGO 最具代表性的产品之一，莓莓夹心软糖自上市以来收获了许多用户的喜爱。此次升级，我们围绕「更真实、更清爽」做了一次全面打磨。" },
      { type: "heading", text: "夹心更多，果味更真" },
      { type: "paragraph", text: "新版本将果酱夹心比例进一步提升，并保留了草莓果肉颗粒。咬开外层软糖，内芯的果酱会更饱满地涌出来。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Macro%20shot%20of%20glossy%20pink%20strawberry%20gummy%20candy%20with%20juicy%20jam%20center%20cut%20open%2C%20clean%20pale%20cream%20background%2C%20soft%20studio%20lighting%2C%20vivid%20food%20photography&width=1200&height=750&seq=tx-news-berry-in1&orientation=landscape", alt: "莓莓夹心软糖的果酱夹心特写" },
      { type: "heading", text: "少糖不寡淡" },
      { type: "paragraph", text: "减糖并不等于减味。研发团队通过调整糖酸比与果酱熬制工艺，让甜味更干净，草莓的风味反而更加突出。" },
      { type: "quote", text: "减糖之后，草莓的香气反而更清楚，这是我们最惊喜的地方。" },
    ],
  },
  {
    id: "annual-award",
    title: "糖心VLGO 荣获「年度新锐甜品品牌」大奖",
    category: "品牌动态",
    date: "2026-02-10",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20trophy%20award%20on%20a%20soft%20cream%20table%20with%20warm%20coral%20accents%20and%20flowers%2C%20minimal%20premium%20award%20ceremony%20photography%2C%20soft%20lighting&width=1200&height=750&seq=tx-news-award&orientation=landscape",
    summary: "凭借对真实用料与产品体验的坚持，糖心VLGO 在行业评选中获得「年度新锐甜品品牌」称号。",
    content: [
      { type: "paragraph", text: "在今年的行业年度评选中，糖心VLGO 荣获「年度新锐甜品品牌」大奖。这份认可属于每一位认真做产品的人，也属于一直支持我们的用户。" },
      { type: "heading", text: "用心，是最长的路" },
      { type: "paragraph", text: "从第一颗软糖开始，我们就把「真实用料」写进了品牌原则。奖项只是结果，真正重要的是每一天的产品体验。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Warm%20coral%20brand%20award%20certificate%20and%20trophy%20on%20a%20minimal%20white%20table%2C%20soft%20lighting%2C%20elegant%20premium%20photography&width=1200&height=750&seq=tx-news-award-in1&orientation=landscape", alt: "糖心VLGO 获得的年度品牌奖项" },
      { type: "paragraph", text: "未来，我们会继续在产品研发、原料溯源与用户沟通上投入更多，让品牌与用户之间的信任更加扎实。" },
    ],
  },
  {
    id: "factory-visit",
    title: "走进糖心VLGO 工厂：一颗软糖的诞生",
    category: "行业观察",
    date: "2026-01-22",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Clean%20modern%20candy%20factory%20production%20line%20with%20warm%20lighting%2C%20organized%20equipment%2C%20soft%20industrial%20photography%2C%20premium%20editorial%20style&width=1200&height=750&seq=tx-news-factory&orientation=landscape",
    summary: "从原料筛选到成品出厂，我们带你看看一颗软糖要经过多少道工序，才能安全又好吃地到达你手中。",
    content: [
      { type: "paragraph", text: "很多用户都好奇：一颗软糖到底是怎么做出来的？这一期，我们走进糖心VLGO 的生产车间，近距离看看产品的诞生过程。" },
      { type: "heading", text: "从原料开始较真" },
      { type: "paragraph", text: "所有进入车间的原料都要经过检验。草莓果酱、果汁浓缩液等原料在入库前会进行批次留样，确保风味与安全稳定。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Clean%20bright%20food%20factory%20interior%20with%20stainless%20steel%20equipment%20and%20warm%20lighting%2C%20organized%20modern%20production%20line%2C%20industrial%20photography&width=1200&height=750&seq=tx-news-factory-in1&orientation=landscape", alt: "糖心VLGO 工厂生产车间" },
      { type: "heading", text: "温度与时间的艺术" },
      { type: "paragraph", text: "软糖的弹性、曲奇的酥松、巧克力的丝滑，背后都是温度与时间的精确控制。每一道工序都有对应的参数标准与抽检环节。" },
      { type: "quote", text: "好吃不是偶然，是把每一个细节都做对之后的结果。" },
      { type: "paragraph", text: "成品在出厂前还会经历多轮抽检，包括外观、口感、微生物等指标，合格后才能入库发货。" },
    ],
  },
  {
    id: "valentine-gift",
    title: "情人节限定礼盒甜蜜上线",
    category: "品牌活动",
    date: "2026-01-30",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20coral%20and%20pink%20valentine%20candy%20gift%20box%20with%20heart%20decor%2C%20soft%20cream%20background%2C%20flowers%2C%20warm%20soft%20lighting%2C%20premium%20gift%20photography&width=1200&height=750&seq=tx-news-valentine&orientation=landscape",
    summary: "情人节限定礼盒温暖上线，粉橙配色的心意包装，搭配经典软糖与巧克力，把甜蜜送给在意的人。",
    content: [
      { type: "paragraph", text: "情人节临近，糖心VLGO 推出限定礼盒，以粉橙配色与心形元素包装，把「糖心」的浪漫传递给在意的人。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Open%20romantic%20valentine%20gift%20box%20filled%20with%20assorted%20candy%20and%20chocolate%2C%20coral%20and%20pink%20tones%2C%20soft%20cream%20background%2C%20warm%20lighting%2C%20premium%20photography&width=1200&height=750&seq=tx-news-valentine-in1&orientation=landscape", alt: "情人节限定礼盒内含产品" },
      { type: "heading", text: "限定内容，心意满满" },
      { type: "paragraph", text: "礼盒内含莓莓夹心软糖、可可脆脆棒与海盐焦糖牛轧糖，另附一张可手写的心意卡片，让表达更真诚。" },
      { type: "paragraph", text: "活动期间，线上官方渠道与线下合作门店同步发售，数量有限。" },
    ],
  },
  {
    id: "illustrator-collab",
    title: "糖心VLGO 与知名插画师联名合作",
    category: "品牌动态",
    date: "2026-01-08",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20warm%20hand%20drawn%20illustration%20artwork%20with%20coral%20and%20pink%20characters%20near%20candy%20packaging%2C%20soft%20cream%20background%2C%20creative%20artistic%20flatlay%20photography&width=1200&height=750&seq=tx-news-collab&orientation=landscape",
    summary: "糖心VLGO 携手知名插画师推出联名系列包装，用温暖的插画讲述品牌「甜一点，暖一点」的主张。",
    content: [
      { type: "paragraph", text: "新年伊始，糖心VLGO 宣布与知名插画师达成联名合作。插画师以「甜蜜日常」为灵感，为品牌创作了一组温暖治愈的视觉形象。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Warm%20hand%20drawn%20illustration%20characters%20on%20candy%20packaging%20design%2C%20coral%20pink%20palette%2C%20soft%20cream%20background%2C%20creative%20flatlay%20photography&width=1200&height=750&seq=tx-news-collab-in1&orientation=landscape", alt: "联名系列插画包装设计" },
      { type: "heading", text: "把甜蜜画出来" },
      { type: "paragraph", text: "联名系列覆盖多款经典产品，包装上的小角色与产品口味一一对应，让选购过程也变得有趣。" },
      { type: "quote", text: "希望看到包装的人，会先被那一点点温暖打动。" },
    ],
  },
  {
    id: "industry-trend-2025",
    title: "关于甜品行业趋势的几点观察",
    category: "行业观察",
    date: "2025-12-15",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Minimal%20dessert%20product%20flatlay%20with%20candy%20and%20cookies%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20food%20photography%2C%20clean%20composition&width=1200&height=750&seq=tx-news-trend&orientation=landscape",
    summary: "减糖、真实用料与情绪价值，正在成为甜品行业的关键词。我们分享一些来自一线的观察与思考。",
    content: [
      { type: "paragraph", text: "过去一年，我们与许多用户和同行交流，发现甜品行业正在发生一些有意思的变化。这里分享我们的几点观察。" },
      { type: "heading", text: "减糖，从趋势到共识" },
      { type: "paragraph", text: "越来越多的消费者开始关注配方表。减糖不再只是营销点，而是产品的基本要求。" },
      { type: "heading", text: "真实用料，建立信任" },
      { type: "paragraph", text: "真实果汁、真实坚果、可溯源的原料，正在成为品牌与用户建立信任的重要方式。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Clean%20ingredients%20flatlay%20with%20fresh%20fruits%20nuts%20and%20candy%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20food%20photography&width=1200&height=750&seq=tx-news-trend-in1&orientation=landscape", alt: "真实原料组成的甜品主题画面" },
      { type: "heading", text: "情绪价值，同样重要" },
      { type: "paragraph", text: "在快节奏的生活里，一份甜点带来的放松与治愈感，本身就是产品价值的一部分。" },
    ],
  },
  {
    id: "winter-drinks",
    title: "冬季暖心热饮系列温暖上线",
    category: "产品发布",
    date: "2025-12-02",
    author: "品牌运营团队",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20winter%20hot%20drink%20in%20a%20cream%20mug%20with%20chocolate%20and%20spices%2C%20soft%20warm%20lighting%2C%20coral%20accents%2C%20premium%20beverage%20photography&width=1200&height=750&seq=tx-news-winter&orientation=landscape",
    summary: "入冬之后，糖心VLGO 推出暖心热饮系列，用可可、焦糖与香料的味道，陪你度过每一个清晨与夜晚。",
    content: [
      { type: "paragraph", text: "天气渐冷，糖心VLGO 上线冬季暖心热饮系列，包含经典热可可、焦糖拿铁风味热饮与香料奶茶风味热饮三款。" },
      { type: "image", src: "https://readdy.ai/api/search-image?query=Three%20warm%20winter%20hot%20drinks%20in%20cream%20mugs%20with%20steam%2C%20soft%20warm%20lighting%2C%20cozy%20coral%20tones%2C%20premium%20beverage%20photography&width=1200&height=750&seq=tx-news-winter-in1&orientation=landscape", alt: "冬季暖心热饮系列三款饮品" },
      { type: "heading", text: "把温暖捧在手心" },
      { type: "paragraph", text: "热饮系列采用独立小袋包装，热水冲泡即可还原浓郁风味，适合办公室、居家与出行场景。" },
      { type: "paragraph", text: "系列上线后广受好评，我们也在持续收集用户反馈，让下一款热饮更贴近大家的口味。" },
    ],
  },
];